/**
 * @generated SignedSource<<0cac6e4cd489a618b582d50ac662ae1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlightDetails_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_data">;
  readonly " $fragmentType": "PackageDateRowFlightDetails_data";
};
export type PackageDateRowFlightDetails_data$key = {
  readonly " $data"?: PackageDateRowFlightDetails_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlightDetails_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "440e2568a830f9be34700cfd0427428e";

export default node;
